import { lazy, Suspense } from "react";

import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/form-components.css";
import "react-toastify/dist/ReactToastify.css";
import "./assets/css/theme.scss";
// Design language: tokens first, then the component layer that maps them onto
// the Bootstrap/MUI primitives. Both must load after bootstrap.min.css.
import "./assets/css/design-tokens.css";
import "./assets/css/design-system.css";

import { Loader } from "./components/Loader/Loader";

import { BrowserRouter as Router } from "react-router-dom";

import { Toaster } from "react-hot-toast";

const RouterComp = lazy(() => import("./Router"));

/* Shown while a lazy route chunk loads. Matches the app's loading veil so a
   route transition doesn't flash unstyled text. */
function RouteFallback() {
  return (
    <div className="nx-route-fallback" role="status" aria-live="polite">
      <div className="nx-spinner" />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <Loader>
        <Toaster
          position="top-center"
          reverseOrder={false}
        />
        <Router>
          <Suspense fallback={<RouteFallback />}>
            <RouterComp />
          </Suspense>
        </Router>
      </Loader>
    </div>
  );
}

export default App;
